<template>
    <v-app class="bg-wrapper">
        <v-main>
            <slider-app-bar 
                :menu-items="navItems" 
                :hide-carousel="$vuetify.breakpoint.smAndDown" 
                :hide-app-logo="$route.path == '/'"
                :title="this.getRouteTitle($route.path)"
                :images="($vuetify.breakpoint.smAndDown ? titleimages.mobile : titleimages.regular)"
            />
            <Title v-if="$route.path != '/'">
                {{ this.getRouteTitle($route.path) }}
            </Title>
            <v-container
                fluid
                :style="($vuetify.breakpoint.mdAndDown ? 'margin-top: 16px; margin-bottom: 16px;' : 'margin-top: 40px; margin-bottom: 40px;') + 'max-width: 2200px;'"
            >
                <router-view />
            </v-container>
        </v-main>
        <AZFooter />
        <Background />
    </v-app>
</template>

<script>
import SliderAppBar from "./components/SliderAppBar.vue";
import AZFooter from "@/components/AZFooter.vue";
import Title from "@/components/Title.vue";
import Background from "@/components/Background/Background.vue";

export default {
    name: 'App',
    components: {
        SliderAppBar,
        AZFooter,
        Title,
        Background
    },
    data: () => ({
        titleimages: {
            mobile: [
                require("@/assets/img/carousel/mobile/carousel_1.jpg"),
                require("@/assets/img/carousel/mobile/carousel_2.jpg"),
                require("@/assets/img/carousel/mobile/carousel_3.jpg"),
                require("@/assets/img/carousel/mobile/carousel_4.jpg")
            ],
            regular: [
                require("@/assets/img/carousel/regular/carousel_1.jpg"),
                require("@/assets/img/carousel/regular/carousel_2.jpg")
            ]
        },
        navItems: [
            {
                type: "multi",
                title: "Informationen",
                hidden: true,
                items: [
                    { title: 'Home', icon: 'mdi-home-circle', route: '/' },
                    { title: 'Das Seminar', icon: 'mdi-information', route: '/seminar' },
                    { title: 'Team', icon: 'mdi-account-multiple', route: '/team' },
                    { title: 'Team2', icon: 'mdi-account-multiple', route: '/team2' },
                    { title: 'FAQs', icon: 'mdi-help-circle', route: '/faqs' },
                    { title: "Alumni*ae Projekte", icon: "mdi-heart", route: "/projekte" },
                    { title: 'Kontakt', icon: 'mdi-email', route: '/contact' }
                ]
            },
            {
                type: "text-button",
                title: "Home",
                route: "/",
                icon: "mdi-home-outline"
            },
            {
                type: "text-button",
                title: "Das Seminar",
                route: "/seminar",
                icon: 'mdi-information-outline'
            },
            {
                type: "text-button",
                title: "Team",
                route: "/team",
                icon: 'mdi-account-multiple-outline'
            },
            {
                type: "text-button",
                title: "FAQs",
                route: "/faqs",
                icon: 'mdi-help-circle-outline'
            },
            {
                type: "text-button",
                title: "Alumni*ae Projekte",
                route: "/projekte",
                icon: "mdi-heart-outline"
            },
            {
                type: "text-button",
                title: "Kontakt",
                route: "/contact",
                icon: "mdi-email-outline"
            },
            {
                type: "text-button",
                title: "Impressionen",
                route: "/impressionen",
                icon: "mdi-image-multiple-outline"
            },
            {
                type: "multi",
                style: "socials",
                title: "Soziale Netzwerke",
                hidden: false,
                items: [
                    {
                        type: "icon-button-external",
                        title: "Instagram",
                        url: "https://www.instagram.com/one_future_ev/",
                        icon: "mdi-instagram"
                    },
                ]
            },
            {
                type: "multi",
                style: "alert",
                title: "Alerts",
                hidden: false,
                items: [
                    {
                        type: "icon-button-external",
                        title: "Unterstützen",
                        url: "https://www.betterplace.org/de/projects/64975-aktion-zukunft",
                        icon: "mdi-heart-plus-outline",
                        color: "#ef5350"
                    },
                ]
            },
            {
                type: "none",
                hidden: true,
                title: "Impressum",
                route: "/legal/imprint"
            },
            {
                type: "none",
                hidden: true,
                title: "Datenschutzerlärung",
                route: "/legal/privacy"
            }
        ],
        drawer: false,
        activeRoute: "",
        activeTitle: ""
    }),
    methods: {
        getRouteTitle(route) {
            return this.navItems.map(el => this.checkObjectType(el)).flat().filter(el => el.route).find(x => x.route.split("/")[1] === route.split("/")[1]).title;
        },
        checkObjectType(object) {
            if(object.items) {
                return object.items.map(el => ({title: el.title, route: el.route}));
            }
            
            return {title: object.title, route: object.route};
        }
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Aktion Zukunft',
        // all titles will be injected into this template
        titleTemplate: '%s'
    }
}
</script>

<style lang="scss">
.search-field {
  margin-right: 16px;
  max-width: 450px;
}

.toolbar_menu {
  width: 100%;
}

.bg-primary {
  /* background-color: map-get($az_colors, green_3) !important; */
  background-color: var(--v-primary-base) !important;
}

.bg-dark {
  background-color: var(--v-secondary-base) !important;
}

html {
  @include root-font-size;
}

.v-main,
.v-footer {
  z-index: 99;
}

.v-main {
  //background: linear-gradient(to bottom right, #b2ebf278, #b2dfdb82);
  background: linear-gradient(
    to bottom right,
    rgba(178, 235, 242, 0.3),
    rgba(128, 222, 234, 0.5)
  );
}

/*
.theme--light.v-sheet,
.theme--light.v-card,
.col {
  background-color: transparent !important;
}
*/

.bg-alpha-white {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

.bg-alpha-white
  *:not(.v-tabs-slider-wrapper .v-tabs-slider):not(.v-timeline
    *):not(.prompt-card):not(.v-alert):not(.v-carousel button) {
  background-color: transparent !important;
}

.main-card {
  .v-card__title {
    font-weight: 300;
    @include main-card-title;
  }

  .v-card__text {
    text-align: justify;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 300;
    padding: 0px 16px 16px 16px;
    @include main-card-text;
  }

  .v-card__subtitle {
    font-size: 1rem;
  }
}
</style>